import{appearingAxis,appearingFinal}from'./cartesian-axis.animation';export default{"initial.axis.gaugeAxis":{"text.appearing":appearingAxis,"path.appearing":appearingAxis},"update.axis.gaugeAxis":{"text.appearing":appearingFinal,"path.appearing":appearingFinal}};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-core/src/axis/gauge.animation.js
// module id = null
// module chunks = 